import type { z } from 'zod';

import { fileQuerySchema } from './file-query-schema';

export const fileFormSchema = fileQuerySchema.pick({ name: true, access_level: true, folder_path: true });

export type FileFormSchema = z.infer<typeof fileFormSchema> & {
  media: File;
};
